import { render, staticRenderFns } from "./DialogCpt.vue?vue&type=template&id=6b9fe3b4&scoped=true&"
import script from "./DialogCpt.vue?vue&type=script&lang=ts&"
export * from "./DialogCpt.vue?vue&type=script&lang=ts&"
import style0 from "./DialogCpt.vue?vue&type=style&index=0&id=6b9fe3b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9fe3b4",
  null
  
)

export default component.exports